import {Injectable} from '@angular/core';
import {CONFIG} from '../config';

@Injectable()
export class ConfigService {
    get(key: string): any {
        if (typeof CONFIG[key] === 'undefined') {
            console.warn('Unknown CONFIG key: ' + key);
            return '';
        }
        return CONFIG[key];
    }
}



// WEBPACK FOOTER //
// /app/src/services/config.service.ts